import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './meeting-info.types';
import * as constants from './meeting-info.constants';

export const meetingInfoReducer = generateResourceReducer<types.IMeetingInfo>({
  STORE: constants.STORE_MEETING_INFO,
  CLEAR: constants.CLEAR_MEETING_INFO,
});
